import {makeAutoObservable} from 'mobx';
import MicrolessonsRepository from '../../../data/repositories/MicrolessonsRepository';
import LoadingModule from '../../LoadingModule/LoadingModule';
import {CreateMicrolessonModel} from '../../../data/models/Microlessons/Microlesson';
import {toast} from 'react-toastify';
import {getErrorFromCode} from '../../../data/errorCodes';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import {createMicrolessonText} from '../createMicrolessonText';

class CreateMicrolessonStore {
  private microlessonsRepo = new MicrolessonsRepository();

  private loadingModule = new LoadingModule();
  private showWizard = false;
  private existingMicrolessonId?: string;
  private onFinishedCallback?: () => void;

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public async createMicrolesson(
    organizationId: string,
    model: CreateMicrolessonModel,
    avatar?: File,
  ) {
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepo.createMicrolesson(
      organizationId,
      model,
      avatar,
    );
    this.loadingModule.endLoading();
    if (!result.success && result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    } else if (result.success) {
      toast.success(createMicrolessonText.microlessonCreated, toastConfig);
    }
    return result;
  }

  public async editMicrolesson(
    organizationId: string,
    lessonId: string,
    model: CreateMicrolessonModel,
    avatar?: File,
  ) {
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepo.editMicrolesson(
      organizationId,
      lessonId,
      model,
      avatar,
    );
    this.loadingModule.endLoading();
    if (!result.success && result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    } else if (result.success) {
      toast.success(createMicrolessonText.microlessonEdited, toastConfig);
    }
    return result.success;
  }

  public async getMicrolesson(organizationId: string) {
    if (!this.existingMicrolessonId) return;
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepo.getMicrolessonById(
      organizationId,
      this.existingMicrolessonId,
    );
    this.loadingModule.endLoading();
    if (result.success && result.data) {
      return result.data;
    }
  }

  public get isShown() {
    return this.showWizard;
  }

  public openWizard(onFinishedCallback?: () => void, microlessonId?: string) {
    this.showWizard = true;
    this.existingMicrolessonId = microlessonId;
    this.onFinishedCallback = onFinishedCallback;
  }

  public hideWizard() {
    this.showWizard = false;
    this.existingMicrolessonId = undefined;
    if (this.onFinishedCallback) {
      this.onFinishedCallback();
      this.onFinishedCallback = undefined;
    }
  }
}

export default CreateMicrolessonStore;
